import { createAsyncThunk, createReducer, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

const name = "maintenance";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReduces(builder);
  },
});

// exports
export const maintenanceAction = { ...slice.actions, ...extraActions };
export const maintenanceReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    applicationMaintenanceList: [],
    paymentGatewayList: [],
    addMaintenanceResponse: null,
    addPaymentGatewayResponse: null,
    UpdateStatusResponse: null,
    loading: false,
    error: null,
  };
}

function createReducers() {
  return {};
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/MaintenanceSchedule`;
  return {
    LoadApplicationMaintenanceList: LoadApplicationMaintenanceList(),
    AddMaintenanceSchedule: AddMaintenanceSchedule(),
    UpdateMaintenanceStatus: UpdateMaintenanceStatus(),
    LoadPaymentGatewayMaintenanceList: LoadPaymentGatewayMaintenanceList(),
    AddPaymentGatewayMaintenance: AddPaymentGatewayMaintenance(),
  };

  function LoadApplicationMaintenanceList() {
    return createAsyncThunk(
      `${name}/LoadApplicationMaintenanceList`,
      async ({ PageNo, RowCountPerPage, SortBy }) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadApplicationMaintenanceList?PageNo=${PageNo}&RowCountPerPage=${RowCountPerPage}&SortBy=${SortBy}`
        );
      }
    );
  }

  function AddMaintenanceSchedule() {
    return createAsyncThunk(`${name}/AddMaintenanceSchedule`, async (param) => {
      return await fetchWrapper.post(
        `${baseUrl}/AddMaintenanceSchedule`,
        param
      );
    });
  }

  function UpdateMaintenanceStatus() {
    return createAsyncThunk(
      `${name}/UpdateMaintenanceStatus`,
      async (param) => {
        return await fetchWrapper.post(
          `${baseUrl}/UpdateMaintenanceStatus`,
          param
        );
      }
    );
  }

  function LoadPaymentGatewayMaintenanceList() {
    return createAsyncThunk(
      `${name}/LoadPaymentGatewayMaintenanceList`,
      async ({ PageNo, RowCountPerPage, SortBy }) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadPaymentGatewayMaintenanceList?PageNo=${PageNo}&RowCountPerPage=${RowCountPerPage}&SortBy=${SortBy}`
        );
      }
    );
  }

  function AddPaymentGatewayMaintenance() {
    return createAsyncThunk(
      `${name}/AddPaymentGatewayMaintenance`,
      async (param) => {
        return await fetchWrapper.post(
          `${baseUrl}/AddPaymentGatewayMaintenance`,
          param
        );
      }
    );
  }
}

function createExtraReduces(builder) {
  //LoadApplicationMaintenanceList Grid Data
  builder
    .addCase(extraActions.LoadApplicationMaintenanceList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadApplicationMaintenanceList.fulfilled,
      (state, action) => {
        state.applicationMaintenanceList = action.payload;
        state.loading = false;
      }
    )
    .addCase(
      extraActions.LoadApplicationMaintenanceList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //AddMaintenanceSchedule
    .addCase(extraActions.AddMaintenanceSchedule.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.AddMaintenanceSchedule.fulfilled, (state, action) => {
      state.addMaintenanceResponse = action.payload;
      state.loading = false;
    })
    .addCase(extraActions.AddMaintenanceSchedule.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //Update Status
    .addCase(extraActions.UpdateMaintenanceStatus.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      extraActions.UpdateMaintenanceStatus.fulfilled,
      (state, action) => {
        state.UpdateStatusResponse = action.payload;
        state.loading = false;
      }
    )
    .addCase(extraActions.UpdateMaintenanceStatus.rejected, (state, action) => {
      state.error = action.error;
    })

    //Grid data for Payment Gateway
    .addCase(
      extraActions.LoadPaymentGatewayMaintenanceList.pending,
      (state) => {
        state.loading = true;
      }
    )
    .addCase(
      extraActions.LoadPaymentGatewayMaintenanceList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.paymentGatewayList = action.payload;
      }
    )
    .addCase(
      extraActions.LoadPaymentGatewayMaintenanceList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    .addCase(extraActions.AddPaymentGatewayMaintenance.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      extraActions.AddPaymentGatewayMaintenance.fulfilled,
      (state, action) => {
        state.loading = false;
        state.addPaymentGatewayResponse = action.payload;
      }
    )
    .addCase(
      extraActions.AddPaymentGatewayMaintenance.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    );
}
